/**
 * Project : workspace
 * File    : StoreCategoryDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.store.category.details

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.feature.productCategory.model.ProductCategory
import com.parmartechnologies.core.navigation.NavigationParam
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.product.ProductCard
import navigation.AppNavigator
import navigation.commerce.route.home.CommerceHomeNavRoute
import presentation.screens.customer.store.component.CartFooter
import theme.ThemeColor

/**
 * Represents the store category detail screen class.
 */

class StoreCategoryDetailScreen {
    fun getProdForCat(products: List<Product>,category: ProductCategory): List<Product>{
        val filteredProd : MutableList<Product> = mutableListOf()
        products.forEach {prd->
            if(prd.CategoryID == category._id){
                filteredProd.add(prd)
            }
        }
        return filteredProd
    }
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun Content() {
        val navParam = AppNavigator.shared().getNavigationParam()
        val viewModel = BusinessViewModel()
        val selectedBusiness = viewModel.selectedBusiness.collectAsState()
        val authViewModel = AuthViewModel()
        val cartViewModel = CartViewModel(business = selectedBusiness.value)
        val productViewModel = ProductViewModel(business = selectedBusiness.value)
        val products = productViewModel.products.collectAsState()
        val filteredProd : List<Product> = getProdForCat(products.value,navParam.productCategory)
        val cartItems = cartViewModel.cartItems.collectAsState()

        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = navParam.productCategory.Name, NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            })
            AppLoader(productViewModel)
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 160.dp),
                modifier = Modifier.weight(1f).padding(
                    start = 0.dp,
                    end = 0.dp,
                ),
            ) {
                items(filteredProd.count()) { index ->
                    ProductCard(
                        products.value[index],
                        cartViewModel,
                        navParam,
                        onClick = { product ->
                            navParam.product = product
                            AppNavigator.shared()
                                .navigate(CommerceHomeNavRoute.PRODUCT, navParam)
                        }).content()
                }
            }
            if (cartItems.value.count() > 0) {
                CartFooter(NavigationParam(), viewModel = cartViewModel) {
                    if (AuthHandler.shared().isLoggedIn()) {
                        AppNavigator.shared().navigate(CommerceHomeNavRoute.SHOPPING_CART)
                    } else {
                        authViewModel.showAuthContainer()
                    }
                }
            }
        }
    }
}